import React, { HTMLProps, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { clamp } from 'lodash';
import { IconButton } from '../../buttons/icon-button/IconButton';
import { Icon } from '../../icons/Icon';
import { NumberInput } from './NumberInput';
import styles from './NumberInputButtons.module.scss';

export const NumberInputButtons = ({ value, min = 0, max = 999, commit, className, ...props }: Props) => {

    const count = useRef<number>(0);
    const isRolling = useRef<boolean>(false);

    const [localValue, setLocalValue] = useState(value);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const ensureValidValue = (amount: number) => clamp(amount, min, max);

    const add = (amount: number) => {
        commit(ensureValidValue(value + amount));
    };

    const setRoller = (amount: number) => {
        setTimeout(() => {
            if (isRolling.current) {
                count.current += 1;
                setLocalValue(localValue => ensureValidValue(localValue + amount));
                setRoller(amount);
            }
        }, plot(count.current, { start: 400, end: 25 }));
    };

    const startRolling = (amount: number) => {
        isRolling.current = true;
        setRoller(amount);
    };

    const stopRolling = () => {
        isRolling.current = false;
        count.current = 0;
        commit(localValue);
    };

    return (
        <div className={classNames(styles.container, className)}>
            <IconButton small
                className={styles.button}
                onClick={() => add(-1)}
                onMouseDown={() => startRolling(-1)} onMouseUp={stopRolling}>
                <Icon type='general-ui-minus' size='small' />
            </IconButton>

            <NumberInput min={min} max={max}
                value={localValue} commit={commit}
                className={styles.input} style={{ width: localValue.toString().length + 'ch' }} {...props} />

            <IconButton small
                className={styles.button}
                onClick={() => add(1)}
                onMouseDown={() => startRolling(1)} onMouseUp={stopRolling}>
                <Icon type='general-ui-plus' size='small' />
            </IconButton>
        </div>
    );
};

// https://www.wolframalpha.com/input?i=400%20%2F%20x%20%20%2B%2025
const plot = (x: number, boundaries: { start: number; end: number }) => {
    return clamp(
        boundaries.start / x + boundaries.end,
        boundaries.end, boundaries.start);
};

type Props = HTMLProps<HTMLInputElement> & {
    value: number;
    min?: number;
    max?: number;
    commit: (value: number) => void;
};